import React from 'react';
import { useDebugMode } from '@bubble-ui/provider-debug-mode';
import View from '@bubble-ui/primitive-view';
import { useDesignVersion } from '@bubble-ui/provider-design-version'; // @ts-expect-error

import SizeMarkerHorizontal from '@bubble-ui/support-size-marker-horizontal';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useDesignContext } from '@klarna/designtokens';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import defaultDesignTokens from './defaultDesignTokens';

var size = function size(_ref) {
  var medium = _ref.medium,
      small = _ref.small,
      large = _ref.large,
      extraLarge = _ref.extraLarge,
      extraExtraLarge = _ref.extraExtraLarge,
      extraSmall = _ref.extraSmall;
  return extraExtraLarge ? 50 : extraLarge ? 30 : large ? 20 : medium ? 15 : small ? 10 : extraSmall ? 5 : undefined;
};

var SpacerHorizontal = function SpacerHorizontal(props) {
  usePropDeprecationWarning({
    componentName: 'SpacerHorizontal',
    propName: 'medium',
    shouldWarn: props.medium !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerHorizontal',
    propName: 'small',
    shouldWarn: props.small !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerHorizontal',
    propName: 'large',
    shouldWarn: props.large !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerHorizontal',
    propName: 'extraLarge',
    shouldWarn: props.extraLarge !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerHorizontal',
    propName: 'extraExtraLarge',
    shouldWarn: props.extraExtraLarge !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  usePropDeprecationWarning({
    componentName: 'SpacerHorizontal',
    propName: 'extraSmall',
    shouldWarn: props.extraSmall !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'spaceToken'
  });
  var visible = props.visible;
  var debugMode = useDebugMode();
  var designVersion = useDesignVersion();
  var designContext = useDesignContext(defaultDesignTokens);
  var sizeValue = props.spaceToken ? designContext.get(props.spaceToken).value() : size(props);

  var _useStyleSheet = useStyleSheet(SpacerHorizontal, getDefaultStyleSheet, {
    designVersion: designVersion,
    sizeValue: sizeValue,
    visible: visible,
    debugMode: debugMode
  }),
      rootStyle = _useStyleSheet.rootStyle;

  return debugMode ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: rootStyle
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(SizeMarkerHorizontal, {
    value: sizeValue
  }))) : /*#__PURE__*/React.createElement(View, {
    style: rootStyle
  });
};

SpacerHorizontal.displayName = 'SpacerHorizontal';
export default withProvisionalOverrideFromContext(SpacerHorizontal);
//# sourceMappingURL=index.js.map